import React from 'react';

import HelpBox from './helpbox/HelpBox';

import 'bootstrap/dist/css/bootstrap.css';
import './helpboxes.styl'

class HelpBoxes extends React.Component {

  render(){
    return (
      <div className="help-boxes">
        <div className="row">
          { this.props.boxes.map(box => {
              return (
                <div key={ box.title } className="col-sm-6 col-md-4">
                  <HelpBox title={ box.title } targetId={ box.targetId }/>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default HelpBoxes;



// WEBPACK FOOTER //
// ./src/components/helpboxes/HelpBoxes.js